// web_components/wcSummary/wcSummary_Renderer.ts

/**
 * Generates the HTML for the wc-summary component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-summary">
        	<div class="wc-summary__container">
				<div>
					<h3>${variables.summaryHeading}</h3>
					<p>${variables.summaryCopy}</p>
				</div>
				<div>
				${
					variables.summaryCTAUrlOptional && variables.summaryCTATextOptional
						? `<a href="${variables.summaryCTAUrlOptional}" class="wc-summary__btn">
								${variables.summaryCTATextOptional}
						  </a>`
						: ''
				}
				<a href="${variables.summaryCTAUrl}" class="wc-summary__btn">
					${variables.summaryCTAText}
				</a>
				</div>
			</div>
        </section>
    `;
}
